export default function () {
  const code = useState<string | null>(() => null);
  const acceptTenantInvite = useAcceptTenantInviteMutation();

  function setCodeToAcceptAfterLogin(newCode: string) {
    code.value = newCode;
  }

  function getCodeToAcceptAfterLogin() {
    return code.value;
  }

  async function acceptCodeAfterLogin(): Promise<boolean> {
    if (code.value) {
      return await acceptCode(code.value);
    }
    return true;
  }

  async function acceptCode(code: string): Promise<boolean> {
    const { error } = await acceptTenantInvite.executeMutation({
      codeInput: {
        code,
      },
    });
    return !error;
  }

  return {
    setCodeToAcceptAfterLogin,
    getCodeToAcceptAfterLogin,
    acceptCodeAfterLogin,
    acceptCode,
  };
}
